import React, { useMemo } from 'react';
import { QrCode, Package, MapPin, Grid3x3 } from 'lucide-react';

const LabelPreview = ({ label }) => {
  const qrData = useMemo(() => {
    try {
      if (label.qr_data) {
        return typeof label.qr_data === 'string' ? JSON.parse(label.qr_data) : label.qr_data;
      }
      return null;
    } catch {
      return null;
    }
  }, [label.qr_data]);

  const statusColors = {
    PENDING: 'bg-amber-50 text-amber-700 border-amber-200',
    PRINTED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    INVALIDATED: 'bg-red-50 text-red-700 border-red-200'
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:border-gray-300 transition-colors">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-50 text-blue-600 rounded-lg">
            <QrCode className="w-5 h-5" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">{label.label_code}</h3>
            <p className="text-sm text-gray-500">
              {label.part_code} - {label.part_name}
            </p>
          </div>
        </div>
        <span className={`px-2 py-1 text-xs font-medium rounded border ${statusColors[label.status] || 'bg-gray-50 text-gray-700 border-gray-200'}`}>
          {label.status}
        </span>
      </div>

      <div className="space-y-2 mb-3">
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Grid3x3 className="w-4 h-4 text-gray-400" />
          <span className="font-medium">Chapa:</span> {label.board_number}
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <MapPin className="w-4 h-4 text-gray-400" />
          <span className="font-medium">Posição:</span> ({label.position_x}, {label.position_y})
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Package className="w-4 h-4 text-gray-400" />
          <span className="font-medium">Dimensões:</span> {label.width} x {label.height}mm
        </div>
      </div>

      {qrData && (
        <div className="mt-3 pt-3 border-t border-gray-200">
          <div className="flex items-center justify-center bg-gray-50 rounded-lg p-2">
            <div className="text-center">
              <div className="w-20 h-20 bg-white border border-gray-300 rounded flex items-center justify-center mx-auto mb-1">
                <QrCode className="w-12 h-12 text-gray-700" />
              </div>
              <p className="text-xs text-gray-500">QR Code</p>
              <p className="text-xs font-mono text-gray-700">{qrData.code}</p>
            </div>
          </div>
        </div>
      )}

      {label.print_count > 0 && (
        <p className="text-xs text-gray-500 mt-2 text-center">
          Impresso {label.print_count} vez(es)
        </p>
      )}
    </div>
  );
};

export default LabelPreview;
